var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9989 7.85649H10.0453V5.94768H8.98118V6.89305H8.03102V7.85148H8.97356V9.02209H7.06103V6.9035H5.04222V9.01904H3.12948V7.85584H4.07332V6.89914H3.12512V5.94484H2.06387V7.84735H1V4.87205H2.05036V3.81058H3.12011V2.95626H4.07637V2.00087H5.03285V2.94624H7.0545V2H8.02122V2.94929H8.97639V3.80317H10.0379V4.86617H11L10.9989 7.85649ZM5.13436 5.39505V4.34534H4.08596V5.39592L5.13436 5.39505ZM7.06975 5.39113H8.11728V4.34774H7.06975V5.39113Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarS);
export default __webpack_public_path__ + "static/media/avatar-s.aa1bc79d7ec0ae3250c033e78fa51959.svg";
export { ForwardRef as ReactComponent };